import React from 'react';
import { Tab as MuiTab} from '@material-ui/core';

const Tab = ({...props}) => <MuiTab {...props}/>

export default Tab;